import { Box, Typography, Grid } from '@mui/material'
import type { TDistributionDetails } from '@modules/types'
import { CartLyricsOnlyDistributionMethod } from '@modules/api-core'
import {
  sectionTitleSx,
  componentFieldLabelSx,
  fieldValueSx,
  distributionDetailCardSx,
} from '../styles'

interface LyricsDistributionSectionProps {
  distributionDetails: TDistributionDetails[]
}

const DistributionField = ({
  label,
  value,
}: {
  label: string
  value: string | number | null | undefined
}) => (
  <Grid size={6}>
    <Typography sx={componentFieldLabelSx}>{label}</Typography>
    <Typography sx={fieldValueSx}>{value ?? 'N/A'}</Typography>
  </Grid>
)

export const LyricsDistributionSection = ({
  distributionDetails,
}: LyricsDistributionSectionProps) => {
  if (!distributionDetails.length) return null

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>
        Distribution Details ({distributionDetails.length})
      </Typography>
      <Box>
        {distributionDetails.map(detail => (
          <Box key={detail.id} sx={distributionDetailCardSx}>
            <Grid container spacing={2}>
              <DistributionField
                label="Format"
                value={CartLyricsOnlyDistributionMethod.displayName(
                  detail.productType ?? detail.distributionMethod,
                )}
              />
              <DistributionField label="Print Run" value={detail.numberOfUnits} />
              <DistributionField label="Retail Price" value={detail.retailPrice} />
            </Grid>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
